import { useEffect } from "react";
import IconFA from "../../../components/icon/icon";
import { useInvoiceContext } from "../../../utils/invoiceContext";

function DbInvoice() {
    const { fetchInvoices, invoicesTotal } = useInvoiceContext();

    useEffect(() => {
        fetchInvoices();
    }, [])

    return (
        <div className="dbContainer">
            <h3 className="dbHeading">
                Rechnungen: {invoicesTotal}
            </h3>
            <IconFA iconName='personWalkingArrowLoopLeft' fontSize='24px' color='black' />
        </div>
    );
}

export default DbInvoice;